import React from "react";
import { Button, Tooltip } from "@mui/material";
import { FileDownloadOutlined, InfoOutlined } from "@mui/icons-material";
import { REPORT_PRIMARY_BUTTON_SX } from "./mfReportsTheme";
import {
  canExportReportPdf,
  getReportPdfDisabledMessage,
} from "../../../utils/reports/reportPdfExport";

type MfReportPdfDownloadButtonProps = {
  columnCount: number;
  hasRows: boolean;
  onExport: () => void;
};

const MfReportPdfDownloadButton: React.FC<MfReportPdfDownloadButtonProps> = ({
  columnCount,
  hasRows,
  onExport,
}) => {
  const tooManyColumns = !canExportReportPdf(columnCount);
  const disabled = !hasRows || tooManyColumns;

  const tooltipTitle = tooManyColumns
    ? getReportPdfDisabledMessage(columnCount)
    : !hasRows
      ? "No data to export"
      : "";

  return (
    <Tooltip
      title={tooltipTitle}
      arrow
      disableHoverListener={!tooltipTitle}
      disableFocusListener={!tooltipTitle}
    >
      <span>
        <Button
          variant="contained"
          size="small"
          startIcon={<FileDownloadOutlined />}
          endIcon={
            tooManyColumns ? (
              <InfoOutlined sx={{ fontSize: 16, opacity: 0.9 }} />
            ) : undefined
          }
          onClick={onExport}
          disabled={disabled}
          sx={{ ...REPORT_PRIMARY_BUTTON_SX, fontSize: 13, px: 2.5, py: 1 }}
        >
          PDF
        </Button>
      </span>
    </Tooltip>
  );
};

export default MfReportPdfDownloadButton;
